// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyBEF2lTj0zvGUQgCBEXsfLIzbOXn9bssbs",
    authDomain: "textsengine.firebaseapp.com",
    projectId: "textsengine",
    storageBucket: "textsengine.firebasestorage.app",
    messagingSenderId: "129781283641",
    appId: "1:129781283641:web:f261ae428add1b8392c6e8",
    measurementId: "G-C9F77VHHH1"
};

// ✅ Initialize Firebase App
const firebaseApp = initializeApp(firebaseConfig)

// ✅ Export Firebase services
const auth = getAuth(firebaseApp)
const db = getFirestore(firebaseApp)
const googleProvider = new GoogleAuthProvider()

export { auth, db, googleProvider }
